<template>
  <div class="mydialog big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="container">
      <div class="box">
        <div class="search-box">
          <div class="item">
            <span class="itemtitle">患者姓名</span>
            <el-input
              v-model="refundForm.patient_name"
              @input="getList"
              clearable
              class="myinput"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="refundForm.doctor_name"
              clearable
              @input="getList"
              class="myinput"
              placeholder="医生"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医生手机</span>
            <el-input
              v-model="refundForm.doctor_phone"
              class="myinput"
              @input="getList"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">支付方式</span>
            <el-select
              v-model="refundForm.pay_type"
              clearable
              class="myinput"
              @change="getList"
            >
              <el-option label="微信" :value="1"></el-option>
              <el-option label="支付宝" :value="2"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">支付来源</span>
            <el-select
              v-model="refundForm.pay_from"
              clearable
              class="myinput"
              @change="getList"
            >
              <el-option label="公众号" :value="1"></el-option>
              <el-option label="APP" :value="2"></el-option>
              <el-option label="小程序" :value="3"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="itemtitle">支付时间</span>
            <el-date-picker
              v-model="refundForm.pay_time"
              type="daterange"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              @change="getList"
              style="width: 225px"
            >
            </el-date-picker>
          </div>
          <div class="item">
            <span class="itemtitle">退款时间</span>
            <el-date-picker
              v-model="refundForm.refund_time"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              @change="getList"
              style="width: 225px"
            >
            </el-date-picker>
          </div>
          <!-- 承担方式 -->
          <div class="item">
            <span class="itemtitle">承担方式</span>
            <div>
              <el-radio-group
                v-model="refundForm.bear_object"
                @change="getList"
                style="margin-left: 5px"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="2">平台</el-radio>
                <el-radio :label="1">医生</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- 备注 -->
          <div class="item">
            <span class="itemtitle">备注</span>
            <el-input
              v-model="refundForm.refund_remark"
              @input="getList"
              clearable
              class="myinput"
            ></el-input>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 20px;
              "
              @click="getList"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :align="item.align"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'refund_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'pay_money'">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      问诊费用:&nbsp;{{ scope.row.consult_money }}元<br />
                      优惠券:&nbsp;-{{ scope.row.coupon_money }}元<br />
                      礼品卡:&nbsp;-{{ scope.row.gift_money }}元<br />
                      合计:&nbsp;{{ scope.row.pay_money }}元<br />
                    </div>
                    <span>{{ scope.row.pay_money }}</span>
                  </el-tooltip>
                </div>

                <div v-else-if="item.prop == 'user_info'">
                  <div>{{ scope.row.real_name }}</div>
                  <div>
                    <span>{{ scope.row.patient_sex | sexText }} </span>&nbsp;
                    <span>{{ scope.row.age }}</span>
                  </div>
                </div>

                <div v-else-if="item.prop == 'doctor_info'">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                  >
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>
                    <span>{{ scope.row.doctor_sex | sexText }} </span>
                    <span> {{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </div>

                <div v-else-if="item.prop == 'consult_type'">
                  <span
                    v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 1
                    "
                    >患者问诊</span
                  >
                  <span v-if="scope.row.consult_type == 2">医生赠送</span>
                  <span v-if="scope.row.consult_type == 3">诊后咨询</span>
                  <span v-if="scope.row.consult_type == 4">预约视频</span>
                  <span v-if="scope.row.consult_type == 5">极速问诊</span>
                  <span
                    v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 2
                    "
                    >视频问诊</span
                  >
                  <span
                    v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 3
                    "
                    >电话问诊</span
                  >
                </div>

                <div v-else-if="item.prop == 'pay_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'pay_type'">
                  {{ scope.row[item.prop] | payTypeText }}
                </div>

                <div v-else-if="item.prop == 'pay_from'">
                  {{ scope.row[item.prop] | payFromText }}
                </div>

                <div v-else-if="item.prop == 'bear_object'">
                  {{ scope.row[item.prop] | bearObjectText }}
                </div>

                <div v-else>
                  {{ !scope.row[item.prop] ? "" : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div>
          <pagination
            v-show="totalNum > 0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import yewu from "../../../api/yewu";
import _ from "lodash";
import dayjs from "dayjs";
import Pagination from "@/components/Pagination/index";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  components: {
    Pagination,
    DocMsg,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      refundForm: {
        patient_name: "",
        doctor_name: "",
        doctor_phone: "",
        pay_type: "",
        pay_from: "",
        pay_time: [],
        refund_time: [],
        bear_object: "",
        refund_remark: "",
        bear_object: 0,
      },
      tableHeader: [
        {
          label: "退款时间",
          prop: "refund_time",
          width: "140",
          align: "center",
          fixed: "left",
        },
        {
          label: "问诊费用",
          prop: "consult_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "实付金额",
          prop: "pay_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "患者信息",
          prop: "user_info",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "科室",
          prop: "department_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生信息",
          prop: "doctor_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "问诊类型",
          prop: "consult_type",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "支付时间",
          prop: "pay_time",
          width: "140",
          align: "center",
          fixed: false,
        },

        {
          label: "支付方式",
          prop: "pay_type",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "支付来源",
          prop: "pay_from",
          width: "100",
          align: "center",
          fixed: false,
        },
        {
          label: "承担方式",
          prop: "bear_object",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "退款原因",
          prop: "refund_desc",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "备注",
          prop: "refund_remark",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      doc_msg: false,
      doctorId: "",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    payTypeText(val) {
      switch (val) {
        case 1:
          return "微信";
        case 2:
          return "支付宝";
      }
    },
    payFromText(val) {
      switch (val) {
        case 1:
          return "公众号";
        case 2:
          return "APP";
        case 3:
          return "小程序";
      }
    },
    bearObjectText(val) {
      switch (val) {
        case 1:
          return "医生承担";
        case 2:
          return "平台承担";
      }
    },
    sexText(val) {
      switch (val) {
        case 0:
          return "未知";
        case 1:
          return "男";
        case 2:
          return "女";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  activated() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.refundForm.refund_time = [start, end];
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getList() {
      let params = Object.assign(this.refundForm, this.pagination, {
        consult_status: 3,
      });
      params = _.omit(params, ["pay_time", "refund_time"]);
      let pay_time = this.refundForm.pay_time;
      let refund_time = this.refundForm.refund_time;
      params["pay_time_start"] = pay_time ? pay_time[0] : "";
      params["pay_time_end"] = pay_time ? pay_time[1] : "";
      params["refund_time_start"] = refund_time ? refund_time[0] : "";
      params["refund_time_end"] = refund_time ? refund_time[1] : "";
      this.tableLoading = true;
      yewu
        .consultList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.tableData = data.list;
            this.totalNum = data.total;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .search-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      margin-right: 15px;
      .itemtitle {
        display: inline-block;
        width: 60px;
        margin-right: 8px;
        text-align: right;
      }
      .myinput {
        width: 140px;
      }
    }
  }
}
</style>
